import { render, staticRenderFns } from "./OrdersAccordion.vue?vue&type=template&id=3c940778"
import script from "./OrdersAccordion.vue?vue&type=script&lang=js"
export * from "./OrdersAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports